import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Option } from '../../../../../core/models/option.model';
import { CustomStoreFinderAdapter } from './custom-store-finder.adapter';
import { PointOfServicesRequestConfig, PointOfServicesStatusRequest } from './custom-store-finder.model';
import { initialStatus } from '../../../../../core/models/request-status.model';

@Injectable({
  providedIn: 'root',
})
export class CustomStoreFinderService {
  pointOfServicesRequestConfig$ = new BehaviorSubject<Partial<PointOfServicesRequestConfig>>({});
  pointOfServicesRequest$ = new BehaviorSubject<PointOfServicesStatusRequest>(initialStatus);

  distances$ = new BehaviorSubject<Option[]>([]);
  units$ = new BehaviorSubject<Option[]>([]);
  products$ = new BehaviorSubject<Option[]>([]);
  types$ = new BehaviorSubject<Option[]>([]);
  googleMapIsLoaded$ = new BehaviorSubject<boolean>(false);

  constructor(private customStoreFinderAdapter: CustomStoreFinderAdapter) {}

  getPointOfServices(config: PointOfServicesRequestConfig) {
    this.pointOfServicesRequestConfig$.next(config);
    return this.customStoreFinderAdapter.getPointOfServices(config);
  }

  clearStores() {
    this.pointOfServicesRequest$.next(initialStatus);
    this.distances$.next([]);
    this.units$.next([]);
    this.products$.next([]);
    this.types$.next([]);
  }
}
